/** Only existing record-launching application paths can become a Back target. */
export function recordReturnTarget(value: unknown): string | undefined {
  if (
    typeof value !== 'string' ||
    value.length > 2048 ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    /[\\\r\n]/.test(value)
  )
    return undefined;
  try {
    const parsed = new URL(value, 'https://cleanlist.invalid');
    if (
      parsed.origin !== 'https://cleanlist.invalid' ||
      !/^\/(?:lists(?:\/[a-zA-Z0-9._~%-]+)?|people(?:\/[a-zA-Z0-9._~%-]+)?|companies(?:\/[a-zA-Z0-9._~%-]+)?|tasks|inbox|finder)\/?$/.test(
        parsed.pathname
      )
    )
      return undefined;
    const recordId = parsed.pathname.split('/')[2];
    if (recordId) {
      const decoded = decodeURIComponent(recordId);
      if (
        decoded === '.' ||
        decoded === '..' ||
        /[/\\?#]/.test(decoded) ||
        [...decoded].some((character) => character.charCodeAt(0) < 32)
      )
        return undefined;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return undefined;
  }
}

export function recordDetailSearch(search: Record<string, unknown>): {
  returnTo?: string;
} {
  const returnTo = recordReturnTarget(search.returnTo);
  return returnTo ? { returnTo } : {};
}
